import { ImageScaleView, View } from '@play-co/timestep-core/ui';
import i18n from 'src/lib/i18n/i18n';
import { Feature } from 'src/replicant/analytics';
import PopupMatch2Base from '../../components/PopupMatch2Base';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import StateObserver from 'src/StateObserver';

// TEST_BPOINTS_FROM_PUZZLE
export default class PopupLeaguesInfoPuzzleCoins extends PopupMatch2Base {
  constructor(opts: { superview: View; close: () => void }) {
    const locale = StateObserver.getLocale() === 'en' ? 'en' : 'ja';

    super({
      superview: opts.superview,
      panelImageOpts: {
        image: 'assets/ui/match2/common/panel_intro.png',
        width: 588,
        height: 859,
        scaleMethod: 'contain',
      },
      offsetY: -140,
      title: {
        type: 'image',
        opts: {
          scaleMethod: 'contain',
          canHandleEvents: false,
          image: `assets/ui/match2/leagues/title_${locale}.png`,
          width: 586,
          height: 79,
          y: 10,
        },
      },
      cta: {
        localeText: () => i18n('match2.leagues.join').toLocaleUpperCase(),
        onClick: () => opts.close(),
        positioning: 'inside',
      },
      tracking: {
        feature: Feature.MATCH2.LEAGUES._,
        $subFeature: Feature.MATCH2.LEAGUES.INTRO_POPUP,
      },
    });

    new LangBitmapFontTextView({
      superview: this.panel,
      x: this.panel.style.width * 0.5,
      y: this.panel.style.height - 195,
      align: 'center',
      verticalAlign: 'center',
      centerOnOrigin: true,
      size: 30,
      font: 'Body',
      width: this.panel.style.width * 0.85,
      height: 100,
      color: '#BF8147',
      wordWrap: true,
      localeText: () => i18n('match2.leagues.messagePuzzleCoins'),
    });

    const hero = new ImageScaleView({
      superview: this.panelView,
      image: `assets/ui/match2/leagues/hero_with_coins.png`,
      width: 500,
      height: 500,
      x: this.panel.style.width * 0.5 - 1,
      y: 335,
      scaleMethod: 'contain',
      centerOnOrigin: true,
      zIndex: -1,
    });

    const frame = new ImageScaleView({
      superview: hero,
      image: `assets/ui/match2/leagues/frame.png`,
      width: 452,
      height: 74,
      centerOnOrigin: true,
      x: hero.style.width * 0.5,
      y: 60,
      scaleMethod: '9slice',
      sourceSlices: {
        horizontal: { left: 40, center: 40, right: 40 },
        vertical: { top: 25, middle: 25, bottom: 25 },
      },
    });

    new LangBitmapFontTextView({
      superview: frame,
      align: 'center',
      verticalAlign: 'center',
      size: 24,
      font: 'Body',
      width: frame.style.width,
      height: frame.style.height,
      color: '#ffffff',
      localeText: () => i18n(`match2.leagues.info`),
    });
  }
}
